  let wallCount = 1; // Start with Wall 1
  // Gets calcualtor-tool div to reference the data-wallpaper-type
  const calculatorTool = document.getElementById("calculator-tool");
  // Rest of object references needed
  const addWallButton = document.getElementById("add-wall");
  const calculateButton = document.getElementById("calculate");
  const resultContainer = document.getElementById("result");
  const resetButton = document.getElementById("reset");
  const widthContainer = document.getElementById("width-container");

  addWallButton.addEventListener("click", function() {
    wallCount++;

    const wallRow = document.createElement("div");
    wallRow.className = "wall-row";

    wallRow.innerHTML = `
      <div class="calculator-row">
        <div class="form__label">
          Wall ${wallCount} Width
        </div>
        <div class="calculator-div">
          <div class="field calculator-feet">
            <input class="field__input" type="number" id="wall-width-feet-${wallCount}" placeholder="0" min="0">
            <span>ft</span>
          </div>
          <div class="field calculator-inches">
            <input class="field__input" type="number" id="wall-width-inches-${wallCount}" placeholder="0" min="0">
            <span>in</span>
          </div>      
        </div>
      </div>
    `;
    widthContainer.appendChild(wallRow);
  });

  calculateButton.addEventListener("click", function() {
    // Get the sum of feet and inches from inputs
    const wallHeight = calculateTotalHeight();
    // To be filled in with 6ft, 8ft or 10ft
    let requiredRollHeight = '';

    // If using WALLPAPER type in block settings
    if (calculatorTool.dataset.wallpaperType == "wallpaper"){
        // If Wall Height is >10ft
      if (wallHeight > 10){
        resultContainer.innerHTML = `For walls greater than 10ft high, please <a href="/pages/contact" class="link">contact us</a> for bespoke services.`
        return; 
      } else if (wallHeight > 8){
        requiredRollHeight = '10ft';
      } else if (wallHeight > 6){
        requiredRollHeight = '8ft';
      } else {
        requiredRollHeight = '6ft';
      }
      const totalInches = calculateTotalWidth(wallCount);
  
      // Convert total inches to rolls (rounding up), dividing by 52in width for wallpaper
      const rolls = Math.ceil(totalInches / 52);
  
      // Update the size variant and quantity selection
      updateSizeAndQuantity(requiredRollHeight, rolls);
      
  
      // Update the resultContainer 
      resultContainer.textContent = `You will need ${rolls}x ${requiredRollHeight} Panel Sets.`;
    //If using 52IN_MURAL in block settings
    } else if (calculatorTool.dataset.wallpaperType == "52in_mural"){
      // If Wall Height is >10ft
      if (wallHeight > 10){
        resultContainer.innerHTML = `For walls greater than 10ft high, please <a href="/pages/contact">contact us</a> for bespoke services.`
        return; 
      } else {
        requiredRollHeight = '10ft';
      }
      const totalInches = calculateTotalWidth(wallCount);
  
      // Convert total inches to rolls (rounding up), dividing by 52in width for 52in_mural
      const rolls = Math.ceil(totalInches / 52);
  
      // Update the size variant and quantity selection
      updateSizeAndQuantity(requiredRollHeight, rolls);
      
  
      // Update the resultContainer 
      resultContainer.textContent = `You will need ${rolls}x ${requiredRollHeight} Mural Sets.`;
    // Only other option is 104IN_MURAL in block settings
    } else {
      // If Wall Height is >10ft
      if (wallHeight > 10){
        resultContainer.innerHTML = `For walls greater than 10ft high, please <a href="/pages/contact">contact us</a> for bespoke services.`
        return; 
      } else {
        requiredRollHeight = '10ft';
      }
      const totalInches = calculateTotalWidth(wallCount);
  
      // Convert total inches to rolls (rounding up), dividing by 104in width for 104in_mural
      const rolls = Math.ceil(totalInches / 104);
  
      // Update the size variant and quantity selection
      updateSizeAndQuantity(requiredRollHeight, rolls);
      
  
      // Update the resultContainer 
      resultContainer.textContent = `You will need ${rolls}x ${requiredRollHeight} Mural Sets.`;
    }
    

  });

  function calculateTotalHeight(){
    // Get the inputs for height
    const wallHeightFeetInput = document.getElementById("wall-height-feet");
    const wallHeightInchesInput = document.getElementById("wall-height-inches");

    // Convert inputs to integers in feet
    const wallHeightFeet = parseInt(wallHeightFeetInput.value, 10) || 0;
    const wallHeightInchesInFeet = parseInt(wallHeightInchesInput.value) / 12 || 0;

    // return the sum of both values in feet
    const totalWallHeight = wallHeightFeet + wallHeightInchesInFeet;

    return totalWallHeight;
  }
  function calculateTotalWidth(count) {
    let totalInches = 0;
    for (let i = 1; i <= count; i++) {
      // Get the inputs
      const feetInput = document.getElementById(`wall-width-feet-${i}`);
      const inchesInput = document.getElementById(`wall-width-inches-${i}`);

      // Convert input values to integers
      const feet = parseInt(feetInput.value, 10) || 0;

      const inches = parseInt(inchesInput.value, 10) || 0;

      // Convert all to inches and add to total
      totalInches += feet * 12 + inches;
    }

    return totalInches;
  }

  // TODO: update to determine if mural is selected instead
  function updateSizeAndQuantity (requiredRollHeight, rolls) {
    // Make the string from calculation match value options of radio buttons based on product type in block settings
    let valueString = '';
    if (calculatorTool.dataset.wallpaperType == 'wallpaper'){
      valueString = requiredRollHeight + ' Panel Set';
    } else {
      valueString = requiredRollHeight + ' Mural Set';
    }
    const radioButtons = document.getElementsByName('Size');

    for (i=0; i < radioButtons.length; i++) {
      if (radioButtons[i].value == valueString){
        radioButtons[i].click();
      }
    }
    // Update quantity to total rolls after 1/2 second to allow for price to update
    setTimeout(function() {
      const quantityInput = document.getElementsByClassName("quantity__input")[0];
      quantityInput.value = rolls;
    }, 500);
    
  }

  resetButton.addEventListener("click", function() {
    // Remove all wall rows except the first
    while(widthContainer.children.length > 1) {
      widthContainer.removeChild(widthContainer.lastChild)
    }
    wallCount = 1;
    resultContainer.textContent = "";
    // Clear input fields
    document.getElementById("wall-height-feet").value = "";
    document.getElementById("wall-height-inches").value = "";
    document.getElementById("wall-width-feet-1").value = "";
    document.getElementById("wall-width-inches-1").value = "";
  })